import { Route, Routes } from "react-router-dom";
import About from "../pages/about/About";
import { BlogDetail } from "../pages/blog/BlogDetail";
import BlogList from "../pages/blog/BlogList";
import Home from "../pages/home/Home";
import { PageNotFound } from "../pages/PageNotFound";
import ProductList from "../pages/products/Products";
import { ProductDetail } from "../pages/products/ProductsDetails";
import BusinessShopPage from "../pages/company/BusinessShopPage";


export const MainRouter = () => {
    return (
        <>
              
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="blog">
                    <Route index element={<BlogList />} />
                    <Route path=":id" element={<BlogDetail />} />
                </Route>
                <Route path="product" >
                    <Route index element={<ProductList />} />
                    <Route path=":id" element={<ProductDetail />} />
                </Route>
                <Route path="company" element={<BusinessShopPage />} />
                <Route path="*" element={<PageNotFound/>} />
            </Routes>
        </>
    );
};